import React from 'react';
import { connect } from 'react-redux';

import * as Constants from '../../Common/constants.js';

import { ReportFeedWidget } from '../ReportFeedWidget/ReportFeedWidget.js';
import API from '../../Api/leaderboard';
import * as Utils from '../../Common/utils.js';
import './PlayerGroupPage.css'; // Tell Webpack that Button.js uses these styles
import PlayerGroupPlayer from './PlayerGroupPlayer.js';
import HoleItem from '../HoleItem/HoleItem.js';


class PlayerGroupPage extends React.Component {

    constructor(props) {

        super(props);

        let params = Utils.getQueryParams(this.props.location.search);
        let tid = params["tid"];
        let gid = params["id"];
        let pid = params["playerid"]


        this.state = { tid: tid, gid: gid, pid: pid, data: null, serverErrors: {}, groupevents: [], showScoutData: false, playerResults: "", holes: [] };

        console.info('PlayerGroupPage - constructor called.', gid);
        this.showData = this.showData.bind(this);

    }
    static getDerivedStateFromProps(props, state) {
        console.info('PlayerGroupPage - getDerivedStateFromProps called.');


        var lastEvent = props.leaderboardData.last;
        if (!lastEvent) {
            return null;
        } else {
            return {
                last: lastEvent,
                prevEvent: state.last
            };
        }

    }

    componentDidMount() {
        console.info('PlayerGroupPage - componentDidMount called.');
        this.fetchPlayerGroup();
        this.myInterval = setInterval(() => this.fetchPlayerGroup(), 30000);
        this.loadPlayerResults();
        // this.listenOnWS();

    }





    componentDidUpdate(prevProps, prevState) {
        if (!this.state.last) {
            return null;
        }
        if (!this.state.data) {
            return null;
        }
        let players = this.state.data.players;
        var maxHoleIndex = -1;
        if (players) {
            players.forEach(element => {
                if (element.currentHole > maxHoleIndex) {
                    maxHoleIndex = element.currentHole;
                }
            });
            if (this.state.last.holeIndex > maxHoleIndex) {
                console.log("reload");

                players.forEach(player => {
                    player.currentHole = this.state.last.holeIndex;
                    this.fetchPlayerEvents(player);
                });
                this.fetchPlayerGroup();
                this.loadPlayerResults();

            }
        } else {
            return null;
        }
    }
    loadPlayerData(lastevent) {
        let data = this.state.data;
        data.players.forEach(player => {

            if (player.id === lastevent.playerId) {
                this.fetchPlayerEvents(player);
            }


        });
    }

    componentWillUnmount() {
        clearInterval(this.myInterval);
    }


    render() {
        console.info('PlayerGroupPage - render called.', this.props, this.state.data);

        if (this.state.data && this.state.playerResults) {
            let group = this.state.data;
            let holes = this.state.holes;
            let results = this.state.playerResults;
            this._currenthole = getCurrentHole(group);
            let playerItems = this.renderPlayerItems(group, results, holes);
            let backArrow = Constants.IMAGE_SERVER + "/images/back_arrow.png";
            let Banner = Constants.IMAGE_SERVER + "/images/banner_small.jpg";
            return (
                <div className="playerGroupBackground" style={{ backgroundColor: '#787878', color: 'white' }}>
                    <div >
                        {this.state.showScoutData ? <div className="scoutDataBox" style={{ width: "200px", width: "200px", backgroundColor: "black" }}></div> : null}
                        <div className="imageContainer">
                            <img className="tournamentBanner" style={{ width: '100%', marginTop: '0px' }} src={Banner} />
                            <div className="imageText">{this.state.chosenPlayer.name}</div>
                        </div>
                    </div>
                    <div className="navmenu">
                    <div className="tourConfirmedExplained" ><span className="confirmedTour" style={{ marginRight: "2px" }}></span> = Tour confirmed </div>
                        <img className="backArrow" src={backArrow} onClick={() => this.props.history.goBack()}></img>
                        <p style={{ position: 'absolute', fontWeight: 800, fontSize: 10 }}>
                            <img style={{ marginRight: '10px', borderRadius: '30%', width: '30px', position: 'absolute', bottom: 0, marginBottom: '5px' }}
                                src={Constants.IMAGE_SERVER + "/images/flags/flag_" + this.state.chosenPlayer.country + ".jpg"} />
                            <span style={{ marginLeft: '45px' }}> {this.state.chosenPlayer.name}</span>
                        </p>
                       {/* <div className="navmenubar">{<img style={{width:'80%',height:"100%",opacity:0.5, position:'absolute', bottom:0, right:0}} 
                                    src={Constants.IMAGE_SERVER + "/images/barflag/barflag_"+this.state.chosenPlayer.country+".png"} />}
            </div>*/}
                    </div>
                    {/*<div className="groupheaderHole"></div>*/}
                    <div className="playerItemsContainer">
                        {playerItems}

                    </div>
                    <div className="group">


                        {/*<div className="holeItemContainer">
                            <HoleItem players={group.players} holeindex={this._currenthole} width={375} height={695}
                                strokes={getStrokesGroupHole(this.state.data, this.props.leaderboardData)} tid={this.state.tid} />
                        </div>*/}

                    </div>
                </div>);

        } else {
            return (<div>Loading data...</div>);
        }
    }

    //<div className="holeItemContainer">
    //                     {<HoleItem players={group.players} holeindex={this._currenthole} width={375} height={675} 
    //                          strokes={getStrokesGroupHole(this.state.data, this.props.leaderboardData)} tid={this.state.tid}/>}
    //                      </div>
    //<img style={{ width: '100%',marginTop:'75px' }} src={require('../../banner.jpg')} />
    renderPlayerItems(group, results, holes) {
        if (!group) {
            return null;
        }
        var playerItems = [];

        var colors = ["rgb(172,45,45)", "rgb(172,152,0)", "rgb(91,63,136)", "black"];
        var colorindex = 0;
        var players = group.players;

        players.forEach(player => {
            player.results = {};
            results.forEach(item => {
                if (item.id == player.id) {
                    player.results = item.results;
                }
            })
            player.color = colors[colorindex++];
            let playerid = player.id;
            var haslastitem = false;
            if (player.id == this.state.pid) {
                this.state.chosenPlayer = player;

                playerItems.push(
                    <PlayerGroupPlayer 
                        onclick={this.showData} 
                        tid={this.state.tid} 
                        gid={this.state.gid} 
                        key={playerid} 
                        data={player} 
                        haslastitem={haslastitem} 
                        leaderboard={this.props.leaderboardData} 
                        hole={this._currenthole} 
                        confirmed={this.props.confirmed} 
                    />
                );
            }
        });


        return playerItems;

    }
    showData() {
        this.setState({ showScoutData: true })
    }
    fetchPlayerGroup() {
        let gid = this.state.gid;
        //http://134.209.230.231:8080/leaderboard/1
        let url = Constants.SERVER + "/group/" + gid;
        console.log(" fetchPlayerGroup with URL:" + url);

        fetch(url)
            .then(response => response.json())
            .then(data => {

                this.compareAndSetState(data);

            }


            ).catch((error) => {
                console.log("error when fetchPlayerGroup", url);
                console.error(error);
            });;


    }
    loadPlayerResults() {
        let url = Constants.SERVER + "/grouptable/" + this.state.gid;

        console.log("loadResultFromBackend", url);
        fetch(url, {
            method: 'GET'
        }).then((response) => response.json())
            .then((responseJson) => {
                this.setState({ playerResults: responseJson.players })
            })
            .catch((error) => {
                console.log("error when loadPlayerFromBackend", url);
                console.error(error);
            });
    }

    fetchPlayerEvents(player) {

        console.log("fetchPlayerEvents!", player);
        let roundIndex = Utils.getRoundIndex(player);
        let holeIndex = Utils.getHoleIndex(player);

        let url = Constants.SERVER + "/playerevent?playerId=" + player.id + "&roundIndex=" + roundIndex + "&holeIndex=" + holeIndex;
        console.log(" fetchPlayerEvents", url);
        fetch(url)
            .then(response => response.json())
            .then(data => {

                let group = this.state.data;
                let oldplayer = findPlayer(player.id, group);
                if (oldplayer) {
                    oldplayer.events = data;
                    this.setState({ ...this.state, data: group });

                }


            }


            ).catch((error) => {
                console.log("error when fetfetchPlayerEvents", url);
                console.error(error);
            });;

    }

    compareAndSetState(data) {
        console.log(" compareAndSetState ", data);

        let oldgroup = this.state.data;
        if (!this.state.data) {

            this.setState({ ...this.state, data: data });

            data.players.forEach(element => {
                this.fetchPlayerEvents(element);
            });
        }
        else {

            var stateHasChanged = false;

            data.players.forEach(player => {

                let oldplayer = findPlayer(player.id, oldgroup);

                if (playerHasChanged(oldplayer, player)) {

                    stateHasChanged = true;
                    oldplayer.currentEvent = player.currentEvent;
                    oldplayer.currentHole = player.currentHole;
                    oldplayer.currentStroke = player.currentStroke;
                    this.fetchPlayerEvents(player);

                }
            });
        }


        //overwrite data?
        //{user: {...this.state.user, [target.name]: target.value}}
        if (stateHasChanged) {
            this.setState({ ...this.state, data: oldgroup });
        }


    }




}

/**
 * Get data from store
 * @param state
 */
const mapStateToProps = state => ({
    userData: state.userData,
    leaderboardData: state.leaderboard,
    confirmed: state.leaderboard.confirmed

});

/**
 * Import action from dir action above - but must be passed to connect method in order to trigger reducer in store
 * @type {{UserUpdate: UserUpdateAction}}
 */
const mapActionsToProps = {

};

export default connect(mapStateToProps, mapActionsToProps)(PlayerGroupPage);

function addScoutEventsToPlayer(player, leaderboardData) {
    if (!leaderboardData) {
        return;
    }
    let scoutevents = leaderboardData.leaderboard ? leaderboardData.leaderboard.events : null;
    let holeindex = Utils.getHoleIndex(player);
    let events = player.events ? player.events : [];
    let lastid = events.length > 0 ? events[events.length - 1].id : -1;

    if (scoutevents) {
        scoutevents.forEach(element => {
            if ("" + element.holeIndex === holeindex && element.playerId === player.id &&
                element.id > lastid) {
                events.push(element);
            }
        });
    }

    player.events = events;
}

function getStrokesGroupHole(group, leaderboardData) {

    let groupevents = [];
    group.players.forEach(function (player) {

        addScoutEventsToPlayer(player, leaderboardData);

        if (player.events) {
            groupevents.push(...player.events);
        }



    });



    if (!groupevents || groupevents.length === 0) {
        return null;
    }

    var strokes = [];

    groupevents.forEach(element => {

        if (element.type == "STROKE") {
            let stroke = JSON.parse(element.data);
            if (stroke.yCoord > 0) {
                strokes.unshift(element);
            }
        }

    });

    return strokes;
}

function getCurrentHole(data) {
    if (!data) {
        return "";
    }

    var maxHoleIndex = 0;
    data.players.forEach(element => {
        if (element.currentHole && element.currentHole > maxHoleIndex) {
            maxHoleIndex = element.currentHole;
        }
    });
    return maxHoleIndex;
}

function playerHasChanged(oldPlayer, newPlayer) {
    if (!newPlayer) {
        return false;
    }

    if (!oldPlayer) {
        return true;
    }

    if (oldPlayer.currentEvent !== newPlayer.currentEvent) {
        return true;
    }

    return false;

}

function findPlayer(id, group) {
    if (!group || !group.players) {
        return null;
    }

    var p = null;
    group.players.forEach(element => {
        if (element.id === id) {
            p = element;
        }
    });

    return p;
}
function getHolePar(event, leaderboard) {
    if (!event) {
        return 0;
    }
    var hole = null;

    if (event.currentHole) {
        hole = event.currentHole;
    } else if (event.holeIndex && event.holeIndex > 0) {
        hole = event.holeIndex;
    }

    if (!hole) {
        console.log("no currentHole in event object");
        return 0;
    }

    if (!leaderboard.courses || !leaderboard.courses[0]) {
        console.log("no courses in leaderboard object");
        return 0;
    }



    let course = leaderboard.courses[0];

    if (!course.holes) {
        console.log("no holes in course object");
        return 0;
    }
    let holeObject = course.holes[hole - 1];

    return holeObject ? holeObject.par : 0;

}


// WEBPACK FOOTER //
// ./src/Components/PlayerGroupPage/index.js